<template>
  <div>
    <v-btn class="default" @click="dialogAtivo = ! dialogAtivo" title="Exibir Tendencia">
      <v-icon color="#000">mdi-chart-line</v-icon>
    </v-btn>

    <sys-dialog
      v-model="dialogAtivo"
      :titulo="`Tendências das Últimas Entradas do produto #${produtosSelecionado.idproduto}`"
      largura="1000"
      ocultar-botao-salvar
    >
      <chart-tendencia-fornecedor
        v-if="dialogAtivo"
        style="height: 350px"
        :params="parametrosDoProduto"
      />
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from "../../../padraoDeLayout/SysDialog";
import {mapGetters} from "vuex";
import ChartTendenciaFornecedor from "./ChartTendenciaFornecedor";

export default {
  name: "TendenciaUltimasEntradas",
  components: {
    ChartTendenciaFornecedor,
    SysDialog
  },
  data: () => ({
    dialogAtivo: false
  }),
  computed: {
    ...mapGetters({
      produtosSelecionado: "detalhe_produto/getProduto",
      filialCompra: "usuario/getFilialCompras"
    }),
    parametrosDoProduto() {
      const {
        idproduto: produto,
        produtos,
        idfornecedor: fornecedor,
        id_grupo: grupo
      } = this.produtosSelecionado

      return {
        produtos: (produtos && produtos.length > 0) ? produtos : [produto],
        fornecedor,
        grupo,
        filial: this.filialCompra
      }
    }
  }
}
</script>

<style scoped>

</style>
